import useResource from "./useResource"

export default function useSelectReferenceTopicRecordsView({ deal, topic }) {
  const key = `deals/${deal.id}/comparables/topics/${topic.id}/available_reference_records/view`
  return useResource({ key })
}
